var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"font-weight-bold fz-21 mt-4"},[_vm._v("Payment")]),_c('v-data-table',{staticClass:"datatable-services",attrs:{"headers":_vm.tblHeaders,"items":_vm.tblItems,"items-per-page":10,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$moment(item.created_at).format("DD/MM/YYYY HH:mm:ss"))+" ")]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.toIDRWithDotFormat(item.amount))+" ")]}},(_vm.tblItems.length > 10)?{key:"footer",fn:function(ref){
var props = ref.props;
return [_c('custom-footer-datatable',{attrs:{"props":props}})]}}:null],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }